import { render, staticRenderFns } from "./autosize-image.vue?vue&type=template&id=27395ead&scoped=true&"
import script from "./autosize-image.vue?vue&type=script&lang=js&"
export * from "./autosize-image.vue?vue&type=script&lang=js&"
import style0 from "./autosize-image.vue?vue&type=style&index=0&id=27395ead&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27395ead",
  null
  
)

export default component.exports